if (!customElements.get("byte-faq")) {
  class ByteFaq extends HTMLElement {
    constructor() {
      super();

      this.boundHandleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.#bindEvents();
    }

    disconnectedCallback() {
      this.#unbindEvents();
    }

    handleClick(event) {
      const trigger = event.target.closest("[data-faq-trigger]");
      if (!trigger) return;

      const item = trigger.closest("[data-faq-item]");
      if (!item) return;

      const shouldOpen = !item.classList.contains("is-open");
      const canOpenMultiple = this.hasAttribute("data-faq-multiple");

      if (shouldOpen && !canOpenMultiple) {
        this.#closeOtherItems(item);
      }

      this.#setItemState(item, shouldOpen);
    }

    #closeOtherItems(currentItem) {
      const openItems = this.querySelectorAll("[data-faq-item].is-open");

      for (const openItem of openItems) {
        if (openItem !== currentItem) this.#setItemState(openItem, false);
      }
    }

    #setItemState(item, isOpen) {
      const trigger = item.querySelector("[data-faq-trigger]");

      item.classList.toggle("is-open", isOpen);
      if (trigger) trigger.setAttribute("aria-expanded", String(isOpen));
    }

    #bindEvents() {
      this.addEventListener("click", this.boundHandleClick);
    }

    #unbindEvents() {
      this.removeEventListener("click", this.boundHandleClick);
    }
  }

  customElements.define("byte-faq", ByteFaq);
}
